import React from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { createSeats, updateSeats } from '~/state/modules/planimetry'
import { PaperContainer } from '~/views/shared'
import { SeatsDistribution } from '../SeatsDistribution'
import { ROUTES } from '~/views/routes'
import { SEATS_STATUS } from 'config/constants'
import history from '~/config/history'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'

export const SeatsCreatePage = ({ onSuccess }) => {
  const { locationId, layoutId, sectorId } = useParams()
  const { pendingCreateSeats, pendingUpdateSeats, sector } = useSelector(
    (state) => state.planimetry
  )

  const dispatch = useDispatch()

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = {
      SectorId: sectorId,
      Column: values.Column,
      Row: values.Row,
      Seats: values.Seats.map((seat) => ({
        Column: seat.column,
        Row: seat.row,
        IsSeat: true,
        Status: SEATS_STATUS[seat.status],
        Id: seat.id
      }))
    }
    try {
      setSubmitting(true)
      if (sector.Capacity === 0) {
        await dispatch(createSeats(payload))
        showSnackbarSuccess('Distribución de asientos Creada!')
      } else {
        await dispatch(updateSeats(payload))
        showSnackbarSuccess('Distribución de asientos Actualizada!')
      }
      onSuccess(locationId, layoutId)
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const getSectorIndexUrl = () => {
    return ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.INDEX.replace(
      ':locationId',
      locationId
    ).replace(':layoutId', layoutId)
  }

  const values = {
    SectorId: sectorId,
    Seats: [],
    Row: 0,
    Column: 0
  }

  return (
    <PaperContainer
      title={
        <>
          Distribución de asientos del sector{' '}
          <span
            style={{
              display: 'inline-block',
              width: sector?.Color && 12,
              height: sector?.Color && 12,
              backgroundColor: sector?.Color || '',
              borderRadius: '50%',
              marginInline: sector?.Color && 4,
              verticalAlign: 'middle'
            }}
          />
          {`"${sector?.Name ?? '-'}"`}
        </>
      }>
      <SeatsDistribution
        values={values}
        actionText='Crear'
        handleSubmit={handleSubmit}
        actionPending={pendingCreateSeats || pendingUpdateSeats}
        onCancel={() => history.push(getSectorIndexUrl())}
      />
    </PaperContainer>
  )
}

export default SeatsCreatePage
